export const UPLOAD_TYPE = {
  NEW_DOCUMENT: 0,
  REPLACE_EXISTING: 2,
  KEEP_BOTH: 1,
};

export const UPLOAD_REQUEST_FROM = {
  AGREEMENT: "agreement",
  ASSOCIATION: "association",
  FOLDER: "folder",
  ASSOCIATION_INSTANCE: "association instance",
  FOLDER_INSTANCE: "folder instance",
};

export const UPLOAD_FLOW = {
  DRAG_AND_DROP: "drag and drop",
  DRAG_AND_DROP_SINGLE_EMAIL_THREAD: "drag and drop single email thread",
  SINGLE_EMAIL_UPLOAD: "single email upload",
  SINGLE_EMAIL_THREAD_UPLOAD_REPLACE_POPUP: "single email thread upload replace popup",
};

export const UPLOAD_DRAG_AND_DROP_SIZE_LIMIT = 35000000;
